{
  "title": "Crear meta",
  "basics": {
    "createGoalFor": "Crear meta para {{whom}}",
    "household": "Hogar",
    "corporation": "Empresa",
    "applyPortfolioAtGoal": "Aplicar cartera a la meta"
  },
  "pickPortfolio": {
    "applyPortfolio": "Aplicar cartera",
    "useTheScores": "Utilice las puntuaciones de idoneidad para seleccionar el nivel de riesgo óptimo para la cartera.",
    "goalSuitabilityScore": "Puntuación de idoneidad de la meta",
    "someonesSuitabilityScore": "Puntuación de idoneidad de {{name}}"
  },
  "recommendedPortfolio": "Modelo de cartera recomendado",
  "goalSummary": "Resumen de metas",
  "pleaseReview": "Revise su información para asegurarse de que sea correcta. Puede editarla más tarde en Metas.",
  "continue": "Continuar",
  "createGoal": "Crear meta",
  "added": "Ha creado una nueva meta",
  "failed": "No se ha podido añadir una nueva meta.",
  "subAccMsg": "Conectemos esta meta a una subcuenta",
  "createSubAccount": "Crear subcuenta",
  "skipforNow": "Omita por ahora",
  "tradingProcess": "Proceso de operación"
}
